<template>
    <div class="list__button-group" >
        <template v-for="(command, i) in menuCommands" :key="i">
            <component :is="'ShipmentList_menu_'+command.name"
                       :disabled="command.disabled"
                       :shipmentId="shipmentId"
                       :packageId="packageId"
                       v-if="command.view"
            />
        </template>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import { accessRight } from "@/lib/access-rights";

    import ShipmentList_menu_edit from "@/components/shipment/ShipmentList_menu_edit.vue";
    import ShipmentList_menu_edit_group from "@/components/shipment/ShipmentList_menu_edit_group.vue";
    import ShipmentList_menu_copy_shipment_id from "@/components/shipment/ShipmentList_menu_copy_shipment_id.vue";
    //import ShipmentList_menu_reports from "@/components/shipment/ShipmentList_menu_reports.vue";
    import ShipmentList_menu_delete from "@/components/shipment/ShipmentList_menu_delete.vue";

    export default {
        name: 'ShipmentsList_shipment_menu',
        mixins: [],
        props: {
            shipmentId: Number,
            packageId: Number,
            commands: {
                type: [Array, Object],
                default: () => [
                    'edit',
                    // 'delete',
                ]
            }
        },
        components: {
            ShipmentList_menu_edit,
            ShipmentList_menu_edit_group,
            //ShipmentList_menu_reports,
            ShipmentList_menu_delete,
            ShipmentList_menu_copy_shipment_id,
        },
        data() {
            return {
                accessRight,
                defCommands: [
                    // {
                    //     name: 'reports',
                    //     view: () => this.shipment.status === 'completed',
                    //     // computedView: 'isShipmentAccessRight_edit',
                    //     disabled: false,
                    //     // computedDisabled: 'isShipmentsNotFullLoad',
                    // },
                    {
                        name: 'edit',
                        view: true,
                        // computedView: 'isShipmentAccessRight_edit',
                        disabled: false,
                        computedDisabled: 'isShipmentsNotFullLoad',
                    },
                    {
                        name: 'edit_group',
                        view: true,
                        // computedView: 'isShipmentAccessRight_edit',
                        disabled: false,
                        computedDisabled: 'isShipmentsNotFullLoad',
                    },
                    {
                        name: 'copy_shipment_id',
                        view: true,
                        // computedView: 'isShipmentAccessRight_edit',
                        disabled: false,
                        computedDisabled: 'isShipmentLiteLoad',
                    },
                    {
                        name: 'delete',
                        view: true,
                        // computedView: 'isShipmentAccessRight_edit',
                        disabled: false,
                        // computedDisabled: 'isShipmentsNotFullLoad',
                    },
                ],
            }
        },
        computed: {
            ...mapGetters([
                "getAppUser",
                "getAppMenus",
                "getShipments",
                "getShipmentsById",
                "getShipmentsFullLoadById",
                "isShipmentsFullLoad",
                "isShipmentsPackagesFullLoad",
                "isShipmentsLiteLoad",
                "isShipmentsPackagesLiteLoad",
            ]),
            isShipmentLiteLoad() {
                return !this.isShipmentsLiteLoad || !this.isShipmentsPackagesLiteLoad
            },
            isShipmentsNotFullLoad () {
                return !this.isShipmentsPackagesFullLoad || !this.isShipmentsFullLoad//[this.shipmentId, ...this.childrenShipmentsIds].filter(id => !this.getShipmentsFullLoadById[id]).length
            },
            shipment() {
                return this.getShipmentsById[this.shipmentId]
            },
            childrenShipmentsIds() {
                return this.getShipments.filter(s => s.main_id == this.shipmentId).map(s => s.id)
            },
            menuCommands() {
                return this.commands.map(c => {
                    if(typeof c === 'string'){
                        c = this.defCommands.find(cmd => cmd.name == c)
                    }
                    let disabled = c?.computedDisabled ? this[c.computedDisabled] :
                        typeof c.disabled == 'function' ? c.disabled() : c.disabled
                    let view = c.computedView ? this[c.computedView] :
                        typeof c.view == 'function' ? c.view() : c.view
                    return {...c, disabled, view}
                })
            },
        },
        methods: {
        },
    }
</script>

<style scoped>

</style>